import React from 'react';

export const EnvelopeIcon = () => (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 2C0 0.89543 0.895431 0 2 0H18C19.1046 0 20 0.895431 20 2V12C20 13.1046 19.1046 14 18 14H2C0.895431 14 0 13.1046 0 12V2ZM18 3.28847V10.5858L13.9739 6.55968L18 3.28847ZM16.4142 2L10 7.21153L3.58581 2L16.4142 2ZM2 3.28847V10.5858L6.02611 6.55968L2 3.28847ZM3.41421 12H16.5858L12.4134 7.8276L10 9.78847L7.58662 7.8276L3.41421 12Z"
            fill="inherit"
        />
    </svg>
);
